/* eslint-disable no-unused-vars */
import React from "react";
import { useState, useTransition } from "react";
import TabButton from "./TabButton";
export const AboutSection = () => {
  const [tab, setTab] = useState("skills");
  const [isPending, startTransition] = useTransition();
  const handleTabChange = (id) => {
    startTransition(() => {
      setTab(id);
    });
  };
  const TAB_DATA = [
    {
      title: "Skills",
      id: "skills",
      content: (
        <ul className="list-desc pl-2">
          <li>Node.js</li>
          <li>JavaScript</li>
          <li>React.js</li>
          <li>HTML</li>
          <li>Tailwind Css</li>
        </ul>
      ),
    },
    {
      title: "Education",
      id: "education",
      content: (
        <ul className="list-desc pl-2">
          <li>Faculty of Arst - Aswan University</li>
          <li>Coursera - Meta</li>
          <li>Iti - Mahara tech</li>
        </ul>
      ),
    },
    {
      title: "Certifications",
      id: "certifications",
      content: (
        <ul className="list-desc pl-2">
          <li>Programming With Javascript - Meta</li>
          <li>Developing With React.js</li>
        </ul>
      ),
    },
  ];

  return (
    <section className="text-white">
      <div className="md:grid md:grid-cols-2 gap-8 items-center py-8 px-4 xl:gap-16 sm:py-16 xl:px-16">
        <img
          src={require("../images/about-image.jpg")}
          alt="About-img"
          className="rounded-lg"
          width={350}
          height={350}
        />
        <div className="mt-4 md:mt-0 text-left flex flex-col h-full">
          <h2 className="text-4xl font-bold text-white mb-4">About Me</h2>
          <p className=" text-base lg:text-xl ">
            I am a Front-end developer, I specialize in creating dynamic and
            responsive web applications using JavaScript and React.js. I have
            experience working with React,Redux,Node.js,and Git. My expertise
            also includes crafting elegant and user-friendly interfaces with
            HTML and Tailwind CSS. Passionate about delivering seamless user
            experiences, I continuously strive to delve into the latest
            technologies to achieve the ultimate in web design and
            functionality.
          </p>
          <div className="flex flex-row justify-start mt-8 text-xl">
            <TabButton
              selectTab={() => handleTabChange("skills")}
              active={tab === "skills"}
            >
              {""}
              Skills{""}
            </TabButton>
            <TabButton
              selectTab={() => handleTabChange("education")}
              active={tab === "education"}
            >
              {""}
              Education{""}
            </TabButton>
            <TabButton
              selectTab={() => handleTabChange("certifications")}
              active={tab === "certifications"}
            >
              {""}
              Certifications{""}
            </TabButton>
          </div>
          <div className="mt-8 text-lg">
            {TAB_DATA.find((t) => t.id === tab).content}
          </div>
        </div>
      </div>
    </section>
  );
};
